import { r as registerInstance, h, H as Host, c as createEvent, g as getElement, F as Fragment } from './index-16dc7dde.js';
import './lookups-705fb53e.js';
import { E as EXTERNAL_PARTNER_NAME } from './analytics-765d4daf.js';
import { D as DEBOUNCED_HANDLER_DELAY, z as PesLinkEnum } from './request.constants-deb285e0.js';
import { s as send, y as viewExternalPartnerLink, C as clickExternalPartnerLinkEvent, j as productSelectorVirtualPageEvent, f as csExitToSchneiderEvent } from './send-33ade633.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { p as pesIconSizes } from './constants-e9ddcc22.js';
import { g as getData, as as productCtasButtonType, av as toInteger_1, a as isMobile, d as deepMerge } from './utils-15ad90ec.js';
import { c as comparator } from './comparator-188d64f5.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { _ as _baseTimes } from './_baseTimes-db8626dd.js';
import { i as identity_1 } from './identity-6651b537.js';
import { d as debounce_1 } from './debounce-e28ac3ab.js';
import { g as getSlottedContent } from './slots-0ebb1813.js';
import { i as isAppRoutingEnabled } from './utils-60b2d521.js';
import { s as setProductSelectorAvailability } from './utils-48a92926.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './isTypedArray-dfccd669.js';
import './toString-da636857.js';
import './pes-router-store-1a105b49.js';
import './index-634d378a.js';
import './pick-bfea8c03.js';
import './_basePickBy-9e484e47.js';
import './_assignValue-8e900715.js';
import './hasIn-6ce0da41.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './types-aae419ee.js';

const bazaarVoiceRatingCss = ".bv__rating{padding-top:10px;box-sizing:border-box;display:block}.bv__rating *,.bv__rating *::before,.bv__rating *::after{box-sizing:inherit}";

let BazaarVoiceRating = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isError = false;
  }
  loadBVScript() {
    var _a;
    const script = document.createElement('script');
    script.src = (_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.scriptUrl;
    script.async = true;
    script.onerror = () => (this.isError = true);
    document.head.appendChild(script);
  }
  componentWillLoad() {
    var _a;
    if ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) {
      this.loadBVScript();
    }
  }
  render() {
    var _a;
    const configured = ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) && !this.isError;
    return (configured && (h(Host, { class: "bv__rating" }, h("div", { class: "product-description__special-review-section" }, h("div", { "data-bv-show": "rating_summary", "data-bv-product-id": this.productId }), h("input", { type: "hidden", id: "bazaarVoiceHidden", value: "true" })))));
  }
};
BazaarVoiceRating.style = bazaarVoiceRatingCss;

const circular = `<svg width="114" height="23" viewBox="0 0 114 23" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect x="0.946289" y="0.0703125" width="112.992" height="21.9685" fill="url(#pattern0)"/>
<defs>
<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_226_818" transform="translate(0 -0.125545) scale(0.003861 0.0198586)"/>
</pattern>
<image id="image0_226_818" width="259" height="63" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>
`;

const circularEconomyCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.circular-economy{border:1px solid #e7e6e6;display:block;padding:10px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-top:20px}@media screen and (max-width: 979px){.circular-economy{margin:0 auto}}.circular-economy .content{font-size:14px;line-height:1.4285714286}:host(:not([dir=\"rtl\"])) .circular-economy .content{padding-right:10px}:host([dir=\"rtl\"]) .circular-economy .content{padding-left:10px}.circular-economy .content-container{padding-top:6px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.link{text-decoration:none;outline:none;display:inline-block;color:#42b4e6;line-height:1.1428571429}.link:hover{text-decoration:underline}";

let PesCircularEconomy = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.renderTooltip = () => (h("pdp-icon-tooltip", { class: "sustainability__tooltip-trigger", icon: "information_stroke", iconSize: pesIconSizes.NANO, iconColor: "grey", position: "top" }, h("div", null, this.data.toolTipMessage, this.data.toolTipLearnMoreUrl && (h("a", { class: "link", href: this.data.toolTipLearnMoreUrl }, this.data.toolTipLearnMoreLabel)))));
    this.renderLink = (linkData) => {
      const { label, link } = linkData;
      if (link && isAnalyticsEnabled()) {
        send(viewExternalPartnerLink, {
          external_partner_name: EXTERNAL_PARTNER_NAME,
          external_partner_url: link,
        });
      }
      return (h("a", { class: "link", href: link, target: "_blank", onClick: () => this.onClick(link) }, label));
    };
  }
  componentWillLoad() {
    return this.getProductCount();
  }
  componentDidLoad() {
    if (this.redirectLink && isAnalyticsEnabled()) {
      send(viewExternalPartnerLink, {
        external_partner_name: EXTERNAL_PARTNER_NAME,
        external_partner_url: this.redirectLink,
      });
    }
  }
  onClick(link) {
    if (isAnalyticsEnabled()) {
      send(clickExternalPartnerLinkEvent, { external_partner_url: link });
    }
  }
  getProductCount() {
    const restUrl = `${this.data.apiEndPointUrl}/${this.countryCode}/${this.productId}`;
    return getData(false, restUrl, this.data.apiKey)
      .then((res) => {
      this.stockRes = res;
    })
      .catch(() => { });
  }
  renderMessageText(bulletPointText) {
    bulletPointText = bulletPointText.replace('{0}', this.stockRes['Circular-Stock-Quantity']);
    this.redirectLink = this.stockRes['Details-URL'];
    if (bulletPointText.indexOf('<a>') === -1 && bulletPointText.indexOf('&lt;a&gt;') === -1) {
      return bulletPointText;
    }
    const stringVal = bulletPointText;
    let regLt = /</g;
    let regGt = />/g;
    if (bulletPointText.indexOf('&lt;a&gt;') !== -1) {
      regLt = /&lt;/g;
      regGt = /&gt;/g;
    }
    const replacedVal = stringVal.replace(regLt, '#').replace(regGt, '#');
    const obj = replacedVal.split('#a#');
    const finalArr = [];
    obj.forEach((_item) => {
      if (_item) {
        if (_item.indexOf('#/a#') > -1) {
          const textVal = _item.split('#/a#');
          finalArr.push({ text: textVal[0], type: 'link' });
          if (textVal.length > 1 && textVal[1] !== '') {
            finalArr.push({ text: textVal[1], type: 'span' });
          }
        }
        else {
          finalArr.push({ text: _item, type: 'span' });
        }
      }
    });
    return (h("span", null, finalArr.map((itemLinks) => {
      if (itemLinks.type === 'link') {
        return this.renderLink({ label: itemLinks.text, link: this.redirectLink });
      }
      return itemLinks.text;
    })));
  }
  render() {
    return (h(Host, null, this.stockRes && this.stockRes['Circular-Stock-Quantity'] > 0 && (h("div", { class: "circular-economy" }, h("div", { class: "image-container" }, h("span", { innerHTML: circular })), h("div", { class: "content-container" }, h("span", { class: "content" }, this.renderMessageText(this.data.message)), this.renderTooltip())))));
  }
};
PesCircularEconomy.style = circularEconomyCss;

const compareControlCss = ":host{box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}";

let CompareControl = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.comparatorClick = createEvent(this, "comparatorClick", 7);
    this.ctaClick = createEvent(this, "ctaClick", 7);
    this.selected = this.isSelected();
    this.disabled = this.isDisabled();
    this.onChange = (e) => {
      this.comparatorClick.emit(this.productId);
      this.ctaClick.emit({
        type: productCtasButtonType.COMPARE,
        initialEvent: e,
        product: {
          id: this.productId,
        },
      });
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  isSelected() {
    return comparator.has(this.productId);
  }
  isDisabled() {
    return comparator.isFull() && !this.selected;
  }
  handleComparatorChange() {
    this.selected = this.isSelected();
    this.disabled = this.isDisabled();
  }
  render() {
    return (h("se-checkbox", { class: "compare-control", label: this.label, selected: this.selected, disabled: this.disabled, onDidChange: this.onChange }));
  }
  get el() { return getElement(this); }
};
CompareControl.style = compareControlCss;

const pesCtaAddedToCartLabelCss = ":host{display:block}.cta-added-to-cart-label{display:block}.cta-added-to-cart-label__content{display:flex;justify-content:center;align-items:center;color:#000000;font-size:0.8125rem;line-height:1.125rem;height:1.125rem;letter-spacing:-0.005rem;margin:10px auto 0;overflow:hidden}:host(:not([dir=\"rtl\"])) .cta-added-to-cart-label__icon{padding-right:2px}:host([dir=\"rtl\"]) .cta-added-to-cart-label__icon{padding-left:2px}";

let PesCtaAddedToCartLabel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = false;
  }
  render() {
    return (h("pes-slide-down-container", { class: "cta-added-to-cart-label", active: this.active }, h("div", { class: "cta-added-to-cart-label__content" }, h("pes-icon", { class: "cta-added-to-cart-label__icon", size: "medium" }, "notification_ok"), h("span", { class: "cta-added-to-cart-label__text" }, h("slot", null)))));
  }
};
PesCtaAddedToCartLabel.style = pesCtaAddedToCartLabelCss;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger_1(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = _castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = _baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

var times_1 = times;

const Container = (props, children, utils) => {
  if (!children.length) {
    return null;
  }
  return (h("div", { class: {
      'cta-area': true,
      'cta-area-pbs': props.isPBS,
      'cta-area--prioritized-buy-now-button': props.prioritizeBuyNowButton,
      'cta-area--has-slotted-discounted-price': props.hasSlottedDiscountedPrice,
    } },
    h("div", { class: "cta-area__container" }, utils.map(children, (child) => {
      var _a;
      return Object.assign(Object.assign({}, child), { vattrs: Object.assign(Object.assign({}, child.vattrs), { class: `${(_a = child.vattrs.class) !== null && _a !== void 0 ? _a : ''} ${child.vattrs.class === 'cta-shoppable' ? '' : 'cta-area__container-block'}` }) });
    }))));
};

const ctaAreaViewCss = ":host{display:block}.cta-area{display:block}@media screen and (max-width: 979px){.cta-area{padding:24px 16px;background:#fafafa;border:1px solid #e7e6e6}}@media screen and (min-width: 980px){.cta-area{border-bottom:1px solid #e7e6e6;padding:24px 0}}@media screen and (min-width: 980px){.cta-area-pbs{border-bottom:none}}@media screen and (min-width: 980px){.cta-area--prioritized-buy-now-button{border-bottom:none !important}}.cta-area__container{display:flex;flex-direction:column}@media screen and (min-width: 980px){.cta-area__container-block:not(.circular-economy-container){max-width:320px}}@media screen and (min-width: 980px){.cta-area__container-skeleton{min-height:160px;max-width:320px}}@media screen and (min-width: 980px){.cta-area__row{margin-top:20px}}@media screen and (max-width: 979px){.cta-area__row{margin-top:16px}}.cta-area__row:first-child{margin-top:0}slot[name=discounted-price]:first-child+.cta-area__row{margin-top:0}@media screen and (min-width: 980px){.cta-area--has-slotted-discounted-price .cta-area__row:first-child{margin-bottom:20px}}@media screen and (max-width: 979px){.cta-area--has-slotted-discounted-price .cta-area__row:first-child{margin-bottom:16px}}@media screen and (min-width: 980px){.cta-area--has-slotted-discounted-price slot[name=discounted-price]:first-child+.cta-area__row{margin-top:20px}}@media screen and (max-width: 979px){.cta-area--has-slotted-discounted-price slot[name=discounted-price]:first-child+.cta-area__row{margin-top:16px}}@media screen and (max-width: 979px){.circular-economy-container{margin-bottom:20px}}@media screen and (max-width: 979px){.cta-area__price-container{margin-left:auto;margin-right:auto}}.cta-area__skeleton{--se-divider:#e6e6e6;--se-background-standard:#ffffff}@media screen and (min-width: 980px){.cta-area__skeleton+.cta-area__skeleton{margin-top:8px}}@media screen and (max-width: 979px){.cta-area__row+.cta-area__quick-actions-container,.cta-area--has-slotted-discounted-price slot[name=discounted-price]+.cta-area__quick-actions-container{margin-top:24px;padding-top:4px;border-top:1px solid #e7e6e6}.cta-area__quick-actions-container:first-child,.cta-area:not(.cta-area--has-slotted-discounted-price) .cta-area__quick-actions-container{margin-top:-16px}.cta-area:not(.cta-area--has-slotted-discounted-price) .cta-area__row+.cta-area__quick-actions-container{margin-top:24px}}@media screen and (min-width: 980px){.cta-area__quick-actions-container{display:none}}@media screen and (max-width: 979px){.cta-area__quick-actions{display:block;text-align:center;margin-top:5px}}@media screen and (min-width: 980px){.cta-area__quick-actions{display:none}}";

const SKELETON_HEIGHT = '40px';
let CtaAreaView = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showAddedToCartLabel = false;
    this.showSkeleton = false;
    this.isInFavorites = false;
    this.isMobile = isMobile();
    this.isPBS = false;
    this.debouncedHandleResize = debounce_1(() => {
      this.isMobile = isMobile();
    }, DEBOUNCED_HANDLER_DELAY);
    this.hasSlottedDiscountedPrice = false;
    this.renderSkeletonRow = (index) => {
      return (h("se-skeleton", { key: index, class: "cta-area__skeleton", width: "100%", height: SKELETON_HEIGHT }));
    };
  }
  windowSizeDidChange() {
    this.debouncedHandleResize();
  }
  componentWillLoad() {
    const slot = this.el.querySelector('slot[name=discounted-price]');
    this.hasSlottedDiscountedPrice = !!getSlottedContent(slot);
  }
  renderPriceSection() {
    return ((this.priceHTML || this.secondaryPrice) && (h("div", { class: "cta-area__row cta-area__price-container" }, h("pes-cta-price", { materialPriceGroup: this.materialPriceGroup, priceFromLabel: this.priceFromLabel, priceHTML: this.priceHTML, secondaryPrice: this.secondaryPrice, tooltipHTML: this.tooltipHTML, previousPriceHTML: this.previousPriceHTML, inStockLabel: this.inStockLabel, vatLabel: this.vatLabel, resellerLabel: this.resellerLabel }))));
  }
  renderProductSelectorRow(type, props) {
    if (!this.rangeSelectorConfig || !this.productSelectorConfig)
      return;
    const selectorButtonProps = props;
    selectorButtonProps.type = type;
    return (h("div", { class: "cta-area__row" }, h("pes-cta-product-selector", { productSelectorConfig: this.productSelectorConfig, rangeSelectorConfig: this.rangeSelectorConfig, isCtaArea: true, buttonProps: selectorButtonProps, showProductSelectorStatus: this.showProductSelectorStatus })));
  }
  renderButton(type, props) {
    var _a, _b, _c;
    if (isEmpty_1(props)) {
      return null;
    }
    if (((_a = this.productSelectorConfig) === null || _a === void 0 ? void 0 : _a.buttonlabel) === props.label
      && !((_b = this.productSelectorConfig) === null || _b === void 0 ? void 0 : _b.enableNewWidget)) {
      return this.renderProductSelectorRow(type, props);
    }
    return (h("div", { class: "cta-area__row" }, h("pes-cta-button", { class: "cta-area__button", type: type, size: "medium", icon: props.icon, iconPosition: props.iconPosition, onDidClick: (event) => props.onClick(event.detail), "data-autotests-id": (_c = props.dataset) === null || _c === void 0 ? void 0 : _c.autotestId }, props.label)));
  }
  renderAddedToCartLabel() {
    if (!this.addedToCartLabel) {
      return null;
    }
    return (h("pes-cta-added-to-cart-label", { active: this.showAddedToCartLabel }, this.addedToCartLabel));
  }
  renderSkeleton() {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__container-skeleton" }, times_1(3, this.renderSkeletonRow))));
  }
  renderQuickActions() {
    if (!this.isMobile) {
      return null;
    }
    const myProductsLabels = this.showFavorites && this.addToMyProductsLabel && this.removeFromMyProductsLabel;
    if (!this.showCompare && !myProductsLabels) {
      return null;
    }
    return (h("div", { class: "cta-area__quick-actions-container" }, h("pes-quick-actions", { class: "cta-area__quick-actions", addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, compareLabel: this.compareLabel, productId: this.productId, showCompare: this.showCompare, showFavorites: this.showFavorites, isInFavorites: this.isInFavorites, isCta: true })));
  }
  renderButtons() {
    var _a, _b;
    const primaryBtn = this.renderButton('primary', (_a = this.buttons) === null || _a === void 0 ? void 0 : _a.primary);
    const [firstSecondaryBtnProps, secondSecondaryBtnProps] = ((_b = this.buttons) === null || _b === void 0 ? void 0 : _b.secondary) || [];
    const firstSecondaryBtn = this.renderButton('secondary', firstSecondaryBtnProps);
    const secondSecondaryBtn = this.renderButton('secondary', secondSecondaryBtnProps);
    if (!primaryBtn && !firstSecondaryBtn && !secondSecondaryBtn) {
      return null;
    }
    return (h(Fragment, null, primaryBtn, firstSecondaryBtn, secondSecondaryBtn, !isAppRoutingEnabled() && this.renderAddedToCartLabel()));
  }
  renderShopSeLink() {
    if (this.showShopSeLoader) {
      return this.renderSkeletonRow;
    }
    return (h("div", { class: "cta-shoppable" }, h("pes-cta-shoppable", { shoppableRedirectionData: this.shoppableRedirectionData, shopSeLink: this.shopSeLink })));
  }
  render() {
    if (this.showSkeleton) {
      return this.renderSkeleton();
    }
    return (h(Container, { hasSlottedDiscountedPrice: this.hasSlottedDiscountedPrice, circularEconomyInfo: this.circularEconomyInfo, prioritizeBuyNowButton: this.prioritizeBuyNowButton, productId: this.productId, localeCode: this.localeCode, countryCode: this.countryCode, isPBS: this.isPBS }, this.renderPriceSection(), h("slot", { name: "discounted-price" }), this.renderButtons(), this.shoppableRedirectionData && this.renderShopSeLink(), this.circularEconomyInfo && (h("div", { class: "circular-economy-container" }, h("pes-circular-economy", { data: this.circularEconomyInfo, productId: this.productId, countryCode: this.countryCode }))), this.renderQuickActions()));
  }
  get el() { return getElement(this); }
};
CtaAreaView.style = ctaAreaViewCss;

const pesCtaAreaViewStickyCss = ":host{display:block}.cta-area-sticky{display:flex;align-items:center;height:50px}:host(:not([dir=\"rtl\"])) .cta-area-sticky{padding-left:20px;padding-right:12px}:host([dir=\"rtl\"]) .cta-area-sticky{padding-right:20px;padding-left:12px}.cta-area-sticky__img{flex:1 1 auto;max-width:30px;height:30px}:host(:not([dir=\"rtl\"])) .cta-area-sticky__img{margin-right:12px}:host([dir=\"rtl\"]) .cta-area-sticky__img{margin-left:12px}.cta-area-sticky__price{overflow:hidden}:host(:not([dir=\"rtl\"])) .cta-area-sticky__price{margin-right:12px}:host([dir=\"rtl\"]) .cta-area-sticky__price{margin-left:12px}@media screen and (max-width: 979px){.cta-area-sticky__price{display:none}}.cta-area-sticky__button{flex:0 1 auto;display:flex;justify-content:flex-end;min-width:0;overflow:hidden}:host(:not([dir=\"rtl\"])) .cta-area-sticky__button{margin-left:auto}:host([dir=\"rtl\"]) .cta-area-sticky__button{margin-right:auto}.cta-area-sticky__quick-actions{overflow:hidden}";

let PesCtaAreaViewSticky = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isInFavorites = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderButton() {
    var _a, _b, _c, _d, _e, _f;
    const type = ((_a = this.buttons) === null || _a === void 0 ? void 0 : _a.primary) ? 'primary' : 'secondary';
    const props = type === 'primary' ? (_b = this.buttons) === null || _b === void 0 ? void 0 : _b[type] : (_d = (_c = this.buttons) === null || _c === void 0 ? void 0 : _c[type]) === null || _d === void 0 ? void 0 : _d[0];
    if (isEmpty_1(props)) {
      return null;
    }
    if (props.label === ((_e = this.productSelectorConfig) === null || _e === void 0 ? void 0 : _e.buttonlabel)
      && !this.productSelectorConfig.enableNewWidget) {
      props.type = type;
      return (h("pes-cta-product-selector", { productSelectorConfig: this.productSelectorConfig, rangeSelectorConfig: this.rangeSelectorConfig, isCtaArea: true, buttonProps: props, showProductSelectorStatus: this.showProductSelectorStatus }));
    }
    return (h("pes-cta-button", { class: "cta-area__button", type: type, size: "small", icon: props.icon, iconPosition: props.iconPosition, onDidClick: (e) => props.onClick(e.detail), "data-autotests-id": (_f = props.dataset) === null || _f === void 0 ? void 0 : _f.autotestId }, props.label));
  }
  renderQuickActions() {
    return (h("pes-quick-actions", { class: "cta-area-sticky__quick-actions", showCompare: false, showFavorites: this.showFavorites, hideOnTablet: false, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, isInFavorites: this.isInFavorites, isStickyBar: true }));
  }
  render() {
    return (h("div", { class: "cta-area-sticky" }, this.imageUrl && this.imageTitle && (h("div", { class: "cta-area-sticky__img" }, h("pes-lazy-img", { src: this.imageUrl, alt: this.imageTitle }))), h("pes-cta-price", { class: "cta-area-sticky__price", priceFromLabel: this.priceFromLabel, priceHTML: this.priceHTML, tooltipHTML: this.tooltipHTML, variant: "stickyBar" }), h("div", { class: "cta-area-sticky__button" }, this.renderButton() || this.renderQuickActions())));
  }
  get el() { return getElement(this); }
};
PesCtaAreaViewSticky.style = pesCtaAreaViewStickyCss;

let CtaProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productSelectorChangeEvent = createEvent(this, "productSelectorChangeEvent", 7);
    this.isCtaArea = false;
    this.showProductSelectorStatus = {
      isExternalState: false,
      loaded: false,
      state: false,
    };
    this.showProductSelector = false;
    this.openProductSelector = (selector) => (_) => {
      const modal = document.createElement('pdp-sc-selector-modal');
      const frame = document.createElement('div');
      frame.id = 'widgetFrame';
      modal.headerLabel = this.selectorConfig.scLabel || 'Select your product';
      modal.appendChild(frame);
      modal.open = true;
      modal.addEventListener('didClose', () => {
        document.body.removeChild(modal);
      });
      document.body.appendChild(modal);
      selector.open(this.selectorConfig);
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent);
      }
    };
    this.renderProductSelector = () => {
      if (!this.rangeSelectorConfig || !this.productSelectorConfig)
        return;
      this.selectorConfig = deepMerge(this.rangeSelectorConfig, this.productSelectorConfig);
      if (!this.showProductSelectorStatus.isExternalState) {
        setProductSelectorAvailability(this.selectorConfig, this.productSelectorConfig).then((state) => {
          return (this.showProductSelector = state);
        });
      }
      if (this.showProductSelectorStatus.isExternalState && this.showProductSelectorStatus.loaded) {
        this.showProductSelector = this.showProductSelectorStatus.state;
      }
      const showCtaSelectorButton = this.selectorConfig.enableProductSelectorButton && this.isCtaArea;
      const showSelectorLink = !(this.selectorConfig.enableProductSelectorButton || this.isCtaArea);
      return (this.showProductSelector
        && (showCtaSelectorButton || showSelectorLink) && (h(Host, { class: "subsection__item" }, h("pes-product-selector", { config: this.selectorConfig, renderFunction: (selector) => {
          if (showCtaSelectorButton) {
            return (h("pes-cta-button", { class: "cta-area__button", type: this.buttonProps.type, size: "medium", icon: this.buttonProps.icon, iconPosition: this.buttonProps.iconPosition, onClick: this.openProductSelector(selector), "data-autotests-id": 'props.dataset?.autotestId' }, this.buttonProps.label));
          }
          if (showSelectorLink) {
            return (h("pes-link", { displayType: PesLinkEnum.button, icon: "product_selector", label: this.selectorConfig.buttonlabel, onClick: this.openProductSelector(selector) }));
          }
        } }))));
    };
  }
  productSelectorChange() {
    this.productSelectorChangeEvent.emit(this.showProductSelector);
  }
  render() {
    return this.renderProductSelector();
  }
  static get watchers() { return {
    "showProductSelector": ["productSelectorChange"]
  }; }
};

const pesCtaShoppableCss = ".cta-shop-se-content{font-size:16px;font-style:normal;font-weight:700;line-height:normal}.cta-shop-se-link{color:#42b4e6;cursor:pointer}";

let PesCtaButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.shoppableRedirectionLabel = '';
    this.shoppableRedirectionClickableLabel = '';
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.shoppableRedirectionLabel = (_a = this.shoppableRedirectionData) === null || _a === void 0 ? void 0 : _a.shoppableRedirectionLabel;
    this.shoppableRedirectionClickableLabel = (_c = (_b = this.shoppableRedirectionData) === null || _b === void 0 ? void 0 : _b.link) === null || _c === void 0 ? void 0 : _c.shoppableRedirectionClickableLabel;
  }
  routeToShopSeLink() {
    send(csExitToSchneiderEvent, { link_url: this.shopSeLink });
    window.open(this.shopSeLink);
  }
  getIcon(type) {
    return h("pes-icon", { size: "micro" }, type);
  }
  render() {
    if (!this.shopSeLink)
      return;
    return (h("div", { class: "cta-shop-se-content" }, h("span", null, this.getIcon('segment_residential'), "\u00A0 ", this.shoppableRedirectionLabel), h("span", { class: "cta-shop-se-link", onClick: () => this.routeToShopSeLink() }, "\u00A0 ", this.shoppableRedirectionClickableLabel, " \u00A0", this.getIcon('action_new_window'))));
  }
};
PesCtaButton.style = pesCtaShoppableCss;

const quickActionsCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.quick-actions{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:center;gap:16px}@media screen and (min-width: 980px){.quick-actions{justify-content:flex-start;gap:24px}}.quick-actions .bv__rating{margin-top:16px}:host(:not([dir=\"rtl\"])) .quick-actions .bv__rating{margin-right:0}:host([dir=\"rtl\"]) .quick-actions .bv__rating{margin-left:0}@media screen and (max-width: 979px){.quick-actions--is-cta .favorite-btn,.quick-actions--is-cta .compare-control{display:flex;margin-top:10px}}@media screen and (min-width: 980px){.quick-actions--is-cta .favorite-btn,.quick-actions--is-cta .compare-control{display:none}}.quick-actions-wrapper{display:flex;align-items:center;margin-bottom:24px;min-height:34px}@media screen and (max-width: 979px){.quick-actions-wrapper{justify-content:center}}.compare-control{color:#333333;line-height:1.5rem;margin-top:9px;min-height:17px}@media screen and (max-width: 979px){.compare-control{margin-top:5px;display:none}}.favorite-btn{margin-top:10px}@media screen and (max-width: 979px){.favorite-btn{display:none}}pes-favorites-button{overflow:hidden;white-space:nowrap}@media screen and (max-width: 979px){.bazaar-voice-rating{width:100%}}";

let QuickActions = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.addToMyProductsButtonDidClick = createEvent(this, "addToMyProductsButtonDidClick", 7);
    this.showFavorites = false;
    this.hideOnTablet = true;
    this.isInFavorites = false;
    this.handleAddToMyProductsClick = (event) => {
      this.addToMyProductsButtonDidClick.emit({
        initialEvent: event,
        isStickyBar: this.isStickyBar,
      });
    };
  }
  renderFavoritesBtn() {
    {
      const addToMyProducts = this.showFavorites && this.addToMyProductsLabel && this.removeFromMyProductsLabel;
      return (addToMyProducts && (h("pes-favorites-button", { class: this.hideOnTablet && 'favorite-btn', addLabel: this.addToMyProductsLabel, removeLabel: this.removeFromMyProductsLabel, isInList: this.isInFavorites, onClick: this.handleAddToMyProductsClick })));
    }
  }
  renderCompareControl() {
    if (!this.showCompare || !this.compareLabel) {
      return null;
    }
    return (h("pes-compare-control", { class: "compare-control", label: this.compareLabel, productId: this.productId }));
  }
  renderRatings() {
    return (h("bazaar-voice-rating", { class: "bazaar-voice-rating", productId: this.productId, bazaarVoiceInfo: this.bazaarVoiceInfo }));
  }
  render() {
    var _a;
    return (h("div", { class: { 'quick-actions-wrapper': true, 'quick-actions--is-cta': this.isCta } }, ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) && this.renderRatings(), h("div", { class: { 'quick-actions': true, 'quick-actions--is-cta': this.isCta } }, this.renderFavoritesBtn(), this.renderCompareControl())));
  }
};
QuickActions.style = quickActionsCss;

export { BazaarVoiceRating as bazaar_voice_rating, PesCircularEconomy as pes_circular_economy, CompareControl as pes_compare_control, PesCtaAddedToCartLabel as pes_cta_added_to_cart_label, CtaAreaView as pes_cta_area_view, PesCtaAreaViewSticky as pes_cta_area_view_sticky, CtaProductSelector as pes_cta_product_selector, PesCtaButton as pes_cta_shoppable, QuickActions as pes_quick_actions };
